import axios from 'axios';
import qs from 'qs';

export const getStudentReviews = (params) =>
  axios.get(`/api/v1/student-reviews?${qs.stringify(params)}`);
